import { isNetworkSentryLog } from '@littlebird/logger/sentry';
import { createSentryTransport } from '@littlebird/logger/transports/sentry';
import * as Sentry from '@sentry/react';

export const sentryTransport = createSentryTransport({
  sentry: Sentry,
  queueTimeout: 7000,
  isNetworkLog: isNetworkSentryLog,
});
